/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Focus_SInputs */

const en_funnel_ob_goal_focus_s = /** @type {(inputs: Funnel_Ob_Goal_Focus_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow along, retain what you read`)
};

const es_funnel_ob_goal_focus_s = /** @type {(inputs: Funnel_Ob_Goal_Focus_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue el texto y retén lo que lees`)
};

/**
* | output |
* | --- |
* | "Follow along, retain what you read" |
*
* @param {Funnel_Ob_Goal_Focus_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_focus_s = /** @type {((inputs?: Funnel_Ob_Goal_Focus_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Focus_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_focus_s(inputs)
	return en_funnel_ob_goal_focus_s(inputs)
});